import Vue from 'vue'
import { HubConnectionBuilder, LogLevel, HttpTransportType } from '@microsoft/signalr'
import { $backEndUrl } from '@serverConfig'
// import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import EventBus from '../mixins/event-bus/eventBus'
import apiTermos from '../services/api-termos'

// Tipos de termos verificados ao fazer login e a data limite de criação para exibição
const TERMOS_LOGIN = [1]
const TERMOS_LOGIN_DATA_LIMITE = '2026-03-20'

// eslint-disable-next-line import/prefer-default-export
export function verificarTermosPendentesLogin() {
  apiTermos.getPendentes(TERMOS_LOGIN, TERMOS_LOGIN_DATA_LIMITE)
    .then(r => {
      if (r.data?.length) EventBus.$emit('termosPendentes', r.data)
      EventBus.$emit('termosPendentesVerificados', !!(r.data?.length))
    })
    .catch(() => { EventBus.$emit('termosPendentesVerificados', false) })
}

let connection = {}

const toastTypes = {
  sucesso: { icon: 'fa-solid fa-circle-check', variant: 'success' },
  success: { icon: 'fa-solid fa-circle-check', variant: 'success' },
  erro: { icon: 'fa-solid fa-circle-exclamation', variant: 'danger' },
  error: { icon: 'fa-solid fa-circle-exclamation', variant: 'danger' },
  concluidocomerros: { icon: 'fa-solid fa-circle-check', variant: 'success' },
  aviso: { icon: 'fa-solid fa-triangle-exclamation', variant: 'warning' },
  warning: { icon: 'fa-solid fa-triangle-exclamation', variant: 'warning' },
  iniciado: { icon: 'fa-solid fa-hourglass-end', variant: 'success' },
}

function showToast(mensagem, tipo) {
  const config = toastTypes[tipo]

  if (!config) {
    return
  }

  Vue.$toast({
    component: ToastificationContent,
    props: { title: mensagem, ...config },
  })
}

function showModal({ title, message, type }) {
  Vue.swal({
    title,
    html: message,
    icon: type, // success | error | warning | info | question
    confirmButtonText: 'Ok',
    showCancelButton: false,
  })
}

// cria a conexão padrão com o backend
function createConnection() {
  return new HubConnectionBuilder()
    .configureLogging(LogLevel.Critical)
  // .configureLogging(LogLevel.Debug)
    .withUrl(`${$backEndUrl}/hubs/events`, {
      transport: HttpTransportType.LongPolling,
    })
    .build()
}

// inicia a conexão e retorna uma promise
function startConnection(connec) {
  return connec.start()
}

// define todos os eventos esperados do backend (caso sejam criados novos eventos lá, necessário incluir aqui para recebê-los)
function setEventHandlers(connec) {
  // const toast = useToast()

  // chamado logo após ser conectado ao hub
  connec.on('conectado', () => {
  })

  connec.on('notificacao', (mensagem, tipoNotificacao) => {
    showToast(mensagem, tipoNotificacao)
  })

  connec.on('notificacaoOrModal', dados => {
    if (dados.notificationType === 'modal') {
      showModal(dados)
    } else if (dados.notificationType === 'pop-pup') {
      showToast(dados.message, dados.type)
    }
  })

  // atualiza a lista de baixa em lote
  connec.on('atualizaBaixa', () => {
    EventBus.$emit('atualizaBaixa')
  })

  connec.on('atualizaObservacoes', () => {
    EventBus.$emit('atualizaObservacoes')
  })

  connec.on('atualizaCertificadosVencidos', () => {
    EventBus.$emit('atualizaCertificadosVencidos')
  })

  connec.on('atualizarPlano', novoPlano => {
    EventBus.$emit('atualizarPlano', novoPlano)
  })

  connec.on('atualizarCredito', credito => {
    EventBus.$emit('atualizarCredito', credito)
  })

  // Recebe termos pendentes enviados ativamente pelo backend
  connec.on('termosPendentes', termos => {
    EventBus.$emit('termosPendentes', termos)
  })

  connec.on('atualizacaoProcuracaoFinalizada', sucesso => {
    EventBus.$emit('atualizacaoProcuracaoFinalizada', sucesso)
  })
}

// chamado quando acontece um erro ou quando o hub é desconectado
function rebootConnection() {
  connection = createConnection()
  startConnection(connection)
    .then(() => {
      connection.invoke('VinculateUser', localStorage.accessToken)
      setEventHandlers(connection)
      connection.onclose(() => rebootConnection())
    }).catch(() => new Promise((resolve, reject) => setTimeout(() => rebootConnection().then(resolve).catch(reject), 5000)))
}

// função de conexão com a hub
function start() {
  connection = createConnection()
  startConnection(connection).then(() => {
    connection.invoke('VinculateUser', localStorage.accessToken)
    setEventHandlers(connection)
    connection.onclose(() => rebootConnection())
  }).catch(() => new Promise((resolve, reject) => setTimeout(() => rebootConnection().then(resolve).catch(reject), 5000)))
}

export default function (startHub = true) {
  if (startHub) start()
  return connection
}
